import getCenter from 'geolib/es/getCenter'
import { MapRef } from 'react-map-gl'
import { Center, City, Coordinates } from '../../types/AddressesGroup'

interface MapToGoAttr {
  geoCenter: Coordinates | false
  mapRef: MapRef | null
  zoom: number
}

export const mapGoTo = (
  geoCenter: Coordinates | false,
  mapRef: MapRef | null,
  zoom: number
): MapToGoAttr | null => {
  if (mapRef && geoCenter) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (mapRef as any).current?.flyTo({
      // The additive number are here to center the city on viewMap.
      // Because height of the map is messing with lat/lng coordinates
      center: [geoCenter.longitude + 0.05, geoCenter.latitude - 0.04],
      zoom: zoom,
      duration: 2000,
    })
  }

  return null
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getGeoCenter = (centers: Center[], city: City) => {
  const centersOfSelectedCity = centers.filter(
    (element: Center) => element.address_group_id === city.id
  )
  const coordinates = centersOfSelectedCity.map((result: Center) => ({
    latitude: result.lat,
    longitude: result.lng,
  }))
  const geoCenter: Coordinates | false = getCenter(coordinates)
  return geoCenter
}
